import { useCallback, useEffect, useState } from 'react';

const HOVER_DELAY = 400;

export const useLongHover = () => {
  const [hovered, setHovered] = useState(false);
  const [hoverInitiated, setHoverInitiated] = useState(false);
  const onHover = useCallback(() => setHoverInitiated(true), []);
  const onCancelHover = useCallback(() => setHoverInitiated(false), []);

  useEffect(() => {
    if (!hoverInitiated) {
      setHovered(false);
      return;
    }
    const timeoutId = setTimeout(() => setHovered(true), HOVER_DELAY);
    return () => clearTimeout(timeoutId);
  }, [hoverInitiated]);

  return {
    hovered,
    onHover,
    onCancelHover,
  };
};
